module.exports = __webpack_public_path__ + "img/Portafolio Mezcla Brava_1.ccf84d81.png";